module.exports = "float PI2 = 6.2831853;"